var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDailyPrice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-092e0edd": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 48,
    viewBox: "0 0 17 48",
    fill: "none",
    className: "option__daily-price-angle",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.812191 26.6412C-0.261685 25.2243 -0.271467 23.2686 0.788183 21.841L17 7.93218e-05L17 48L0.812191 26.6412Z",
    fill: "#EAE9F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyPrice);
export default __webpack_public_path__ + "static/media/daily_price.3ffd4be0f57626015ca2264203639cb8.svg";
export { ForwardRef as ReactComponent };